import CloseIcon from "../../../../assets/icons/CloseIcon.js";
import { MODAL_COLUMNS, useViewDetailsModal } from "./viewDetailsModalData.js";

import "./index.scss";

const ViewDetailsModal = ({ isOpen, onClose, data }) => {
  const { getFormattedValue, handleViewCertiButtonClick } =
    useViewDetailsModal(data);

  return (
    isOpen && (
      <>
        <div className="modal-overlay" onClick={onClose} />
        <div className="view-details-modal">
          <div className="modal-header">
            <h2 className="modal-title">Details</h2>
            <button
              className="modal-close-btn"
              onClick={onClose}
              aria-label="Close modal"
            >
              <CloseIcon />
            </button>
          </div>

          <div className="modal-content">
            {MODAL_COLUMNS.map((col) => (
              <div key={col.key} className="detail-row">
                <span className="detail-label">{col.label}:</span>
                <span className="detail-value">
                  {getFormattedValue(col) || "-"}
                </span>
              </div>
            ))}

            {data?.certificate_Url && (
              <button
                className="view-certi-button"
                onClick={() =>
                  handleViewCertiButtonClick(data?.certificate_Url)
                }
              >
                View Certificate
              </button>
            )}
          </div>
        </div>
      </>
    )
  );
};

export default ViewDetailsModal;
